<template>
  <div class="features-1 row pb-0 ml-0 mr-0 property-detail">
    <div class="col-lg-10 m-auto px-0 ovf-h">
      <!-- 사진 -->
      <!-- 건물명 용도 전세가격 -->
      <div class="jipvio_title">
        <ul class="jipvio-text-left p-0">
          <div>
            <li class="fl" style="font-weight: 500;">
              {{ pptDetailInfo.name }}
            </li>
            <li class="fl middle_line">
              {{
                pptDetailInfo.type != null
                  ? sessionCoCodeMapDetail.BPP[pptDetailInfo.type].name
                  : ""
              }}
            </li>
          </div>
          <div>
            <li class="fl" style="font-weight: bold">
              <span>{{
                pptDetailInfo.paymentType != null
                  ? sessionCoCodeMapDetail.PTT[pptDetailInfo.paymentType].name
                  : ""
              }}</span>
              {{ addUnit(this.pptDetailInfo.deposit) }}
            </li>
          </div>
          <!-- <li class="fl jipvio_button">
            <el-button round>문의하기</el-button>
          </li> -->
        </ul>
      </div>
      <div class="row mb-30" id="imageOb">
        <div class="col-xl-8">
          <!-- <div id="jj"></div> -->
          <!-- <img :src="myTestList[VRindex]" /> -->
          <!-- <Vr360 :imgSrc="myTestList[VRindex]" /> -->
          <!-- <iframe :src="url" ></iframe> -->

          <JipvioVR :urls="vrImgUrlList"></JipvioVR>
          <!-- <div
            v-show="loading"
            v-loading="loading"
            style="width: 100%; height: 100%; position: absolute !important"
          ></div>
          <Pano @on-load="onLoad" :source="vrImgUrlList[VRindex]"></Pano>
          <i class="jipvio-ui-icons-360_vr"></i>

          <button class="prevBtn" @click="prevVR()">
            <i class="el-icon-arrow-left" style="cursor: pointer"></i>
          </button>
          <button class="nextBtn" @click="nextVR()">
            <i class="el-icon-arrow-right" style="cursor: pointer"></i>
          </button> -->
        </div>

        <div class="col-xl-4" v-show="showCarsl">
          <el-carousel
            v-show="showGeneralImages"
            trigger="click"
            :interval="0"
            ref="carousel2"
            arrow="always"
          >
            <!-- 일반 이미지 -->
            <ul v-for="iu in carslImg" :key="iu.index">
              <el-carousel-item v-if="hasOwnPropertyByGeneral(iu)" name="index">
                <!-- :style="{ backgroundImage: 'url(' + iu.gimgFileUrl + ')' }" -->
                <el-image :src="iu.gimgFileUrl" @click="overlay"> </el-image>
              </el-carousel-item>
            </ul>
          </el-carousel>
          <el-carousel
            v-show="!showGeneralImages"
            trigger="click"
            :interval="0"
            ref="carousel"
            arrow="always"
          >
            <!-- 열화상 이미지 -->
            <ul v-for="iu in carslImg" :key="iu.index">
              <el-carousel-item v-if="hasOwnProperty(iu)" name="index">
                <!-- :style="{ backgroundImage: 'url(' + iu.thImgFileUrl + ')' }" -->
                <el-image :src="iu.thImgFileUrl" @click="overlay"> </el-image>
              </el-carousel-item>
            </ul>
          </el-carousel>
          <el-button id="carousel_fullscreen" @click="overlay">
            <i class="el-icon-full-screen"></i>
          </el-button>
          <div class="row mr-0 ml-0 px-0">
            <el-button class="col-6 px-0" @click="tag(0)">
              일반 이미지
            </el-button>
            <el-button class="col-6 ml-0 px-0" @click="tag(1)">
              열화상 이미지
            </el-button>
          </div>
        </div>
        <!-- 모바일 일반/열화상 이미지 -->
        <div class="col-xl-4" v-show="!showCarsl">
          <el-carousel
            trigger="click"
            :interval="6000"
            type="card"
            ref="carousel5"
            arrow="always"
          >
            <ul v-for="(iu, index) in carslImg" :key="iu.index">
              <li v-if="hasOwnProperty_G_TH(iu, index)" name="index">
                <el-carousel-item>
                  <img :src="iu.gimgFileUrl" @click="overlay2" />
                </el-carousel-item>
                <el-carousel-item>
                  <img :src="iu.thImgFileUrl" @click="overlay3" />
                </el-carousel-item>
              </li>
            </ul>
          </el-carousel>
          <el-button id="m_carousel_fullscreen" @click="overlay">
            <i class="el-icon-full-screen"></i>
          </el-button>
        </div>
      </div>

      <!-- 매물 정보 -->
      <div id="section1">
        <!-- 타이틀 -->
        <div class="section_title">
          <h4>매물정보 <span>확인매물 2020.10.23</span></h4>
          <!-- <div class="actions row">
            <ul class="row px-0 m-auto">
              <li class="col-6 pr-15 pl-0">
                <i class="jipvio-ui-icons-add_share_line"></i>
              </li> -->
          <!-- <li class="col-6 pr-15 pl-0"><img :src="star" /></li> -->
          <!--<li class="col-6 pr-15 pl-0">
                <i class="jipvio-ui-icons-love"></i>
              </li>
            </ul>
          </div> -->
        </div>
        <!-- 1번 줄 -->
        <div class="row ml-0 mr-0 p-0 line">
          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half">
            <div class="line_half_content col-6 px-0 mx-w1">
              <h6 class="mb-0">거래형태</h6>
            </div>
            <div class="line_half_content col-6 px-0 row mx-w2">
              <h6 class="ftw-400 mb-0">
                {{
                  pptDetailInfo.paymentType != null
                    ? sessionCoCodeMapDetail.PTT[pptDetailInfo.paymentType].name
                    : ""
                }}
              </h6>
            </div>
          </div>

          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half">
            <div class="line_half_content col-6 px-0">
              <h6 class="mb-0 ml-reset">보증금</h6>
            </div>
            <div class="line_half_content col-6 px-0">
              <h6 class="ftw-400 mb-0 ml-reset">
                {{ addUnit(this.pptDetailInfo.deposit) }}
              </h6>
            </div>
          </div>

          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half">
            <div class="line_half_content col-6 px-0">
              <h6 class="mb-0">방/욕실 수</h6>
            </div>
            <div class="line_half_content col-6 px-0">
              <h6 class="ftw-400 mb-0">
                {{ pptDetailInfo.roomCnt }}개/{{ pptDetailInfo.wroomCnt }}개
              </h6>
            </div>
          </div>

          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half">
            <div class="line_half_content col-6 px-0">
              <h6 class="mb-0 ml-reset">전용/공급면적</h6>
            </div>
            <div class="line_half_content col-6 px-0">
              <div class="repeat_content" v-show="Area">
                <h6 class="ftw-400 mb-0 ml-reset">
                  {{ pptDetailInfo.useArea }}/{{ pptDetailInfo.proArea }}㎡
                  <br />
                  <i
                    @click="toggleButton"
                    class="fas fa-exchange-alt repeat_button jvo-impot"
                    style="font-weight: bold"
                  ></i>
                  평
                </h6>
              </div>
              <div class="repeat_content" v-show="!Area">
                <h6 class="ftw-400 mb-0 ml-reset">
                  {{ useAreaP }} / {{ supplyAreaP }}평
                  <br />
                  <i
                    @click="toggleButton"
                    class="fas fa-exchange-alt repeat_button jipvio-color1"
                    style="font-weight: bold"
                  >
                  </i>
                  ㎡
                </h6>
              </div>
            </div>
          </div>

          <!-- 2번 줄 -->
          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half">
            <div class="line_half_content col-6 px-0 mx-w1">
              <h6 class="mb-0">해당층/총층</h6>
            </div>
            <div class="line_half_content col-6 px-0 row mx-w2">
              <h6 class="ftw-400 mb-0">
                {{ pptDetailInfo.floor }}/{{ pptDetailInfo.story }}층
                <el-tooltip
                  effect="dark"
                  placement="top-start"
                  popper-class="jivpio_tooltip3"
                  class="tooltip_P jvo-impot"
                >
                  <div slot="content">
                    <p>
                      <strong
                        >* 공인중개사법 제18조의2(중개대상물의 표시·광고)<br />
                        개정안에 의거하여 의뢰인이 원치 않으실 경우,</strong
                      ><br />
                      다음과 같이 정보를 공개합니다.
                    </p>
                    <p>
                      1. 단독주택의 경우 지번을 읍․면․동․리까지 표시 가능<br />
                      2. 공동주택의 경우 층을 저중고 로 대체 가능
                    </p>
                  </div>
                  <i class="fas fa-exclamation-circle"></i>
                </el-tooltip>
              </h6>
            </div>
          </div>

          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half">
            <div class="line_half_content col-6 px-0">
              <h6 class="mb-0 ml-reset">주차여부</h6>
            </div>
            <div class="line_half_content col-6 px-0">
              <h6 class="ftw-400 mb-0 ml-reset">
                {{ parkingYn }}/세대당 {{ pptDetailInfo.faParkingCnt }}대
              </h6>
            </div>
          </div>

          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half">
            <div class="line_half_content col-6 px-0">
              <h6 class="mb-0">승강기</h6>
            </div>
            <div class="line_half_content col-6 px-0">
              <h6 class="ftw-400 mb-0">
                {{ eleYn }}
              </h6>
            </div>
          </div>
          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half">
            <div class="line_half_content col-6 px-0">
              <h6 class="mb-0 ml-reset">방향/기준</h6>
            </div>
            <div class="line_half_content col-6 px-0">
              <h6 class="ftw-400 mb-0 ml-reset">
                {{
                  pptDetailInfo.direction != null
                    ? sessionCoCodeMapDetail.DRT[pptDetailInfo.direction].name
                    : ""
                }}
                /
                {{
                  pptDetailInfo.directionCri != null
                    ? sessionCoCodeMapDetail.DST[pptDetailInfo.directionCri]
                        .name
                    : ""
                }}
              </h6>
            </div>
          </div>

          <!-- 3번 줄 -->
          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half">
            <div class="line_half_content col-sm-6 col-5 px-0 mx-w1">
              <h6 class="mb-0">관리비</h6>
            </div>
            <div class="line_half_content col-sm-6 col-7 px-0 row mx-w2">
              <!-- {{ pptDetailInfo.mtncFee }} -->
              <div class="col-5 p-0 mx-w2_1">
                <h6 class="ftw-400 mb-0">
                  {{ addUnit(this.pptDetailInfo.mtncFee) }}
                </h6>
              </div>
              <div class="col-7 p-0 mx-w2_2">
                <h6 class="ftw-400 mb-0">
                  <el-tooltip
                    effect="dark"
                    placement="top-start"
                    popper-class="jivpio_tooltip1"
                    class="jvo-impot"
                  >
                    <div slot="content">
                      {{ mtncList }}
                    </div>
                    <i class="fas fa-exclamation-circle"></i>
                  </el-tooltip>
                  포함항목
                </h6>
              </div>
            </div>
          </div>

          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half">
            <div class="line_half_content col-6 px-0">
              <h6 class="mb-0 ml-reset">사용료</h6>
            </div>
            <div class="line_half_content col-6 row pr-0">
              <h6 class="ftw-400 mb-0 ml-reset">
                {{ useFeeYn }}
                <el-tooltip
                  effect="dark"
                  placement="top-start"
                  popper-class="jivpio_tooltip1"
                  class="tooltip_P jvo-impot"
                >
                  <div slot="content">
                    {{ useList }}
                  </div>
                  <i class="fas fa-exclamation-circle"></i>
                </el-tooltip>
                항목
              </h6>
            </div>
          </div>

          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half">
            <div class="line_half_content col-6 px-0">
              <h6 class="mb-0">현관구조</h6>
            </div>
            <div class="line_half_content col-6 px-0">
              <h6 class="ftw-400 mb-0">
                {{
                  pptDetailInfo.entType != null
                    ? sessionCoCodeMapDetail.ETT[pptDetailInfo.entType].name
                    : ""
                }}
              </h6>
            </div>
          </div>
          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half">
            <div class="line_half_content col-6 px-0">
              <h6 class="mb-0 ml-reset">입주가능일</h6>
            </div>
            <div class="line_half_content word_space col-6 px-0">
              <h6 class="ftw-400 mb-0 ml-reset">
                {{ mvDateShow }} <br />이후 입주협의
              </h6>
            </div>
          </div>

          <!-- 4번 줄 -->
          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half">
            <div class="line_half_content col-6 px-0 mx-w1">
              <h6 class="mb-0">베란다/발코니</h6>
            </div>
            <div class="line_half_content col-6 px-0 row mx-w2">
              <h6 class="ftw-400 mb-0">{{ verandaYn }}/{{ balconyYn }}</h6>
            </div>
          </div>
          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half">
            <div class="line_half_content col-6 px-0">
              <h6 class="mb-0 ml-reset">난방방식</h6>
            </div>
            <div class="line_half_content col-6 px-0">
              <h6 class="ftw-400 mb-0 ml-reset">
                {{
                  pptDetailInfo.heatingType != null
                    ? sessionCoCodeMapDetail.HTT[pptDetailInfo.heatingType].name
                    : ""
                }}
              </h6>
            </div>
          </div>

          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half p-0">
            <div class="line_half_content col-6 px-0">
              <h6 class="mb-0">난방연료</h6>
            </div>
            <div class="line_half_content col-6 px-0">
              <h6 class="ftw-400 mb-0">
                {{
                  pptDetailInfo.heatingFuelType != null
                    ? sessionCoCodeMapDetail.HFT[pptDetailInfo.heatingFuelType]
                        .name
                    : ""
                }}
              </h6>
            </div>
          </div>
          <div
            class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half border-ctl"
          >
            <div class="line_half_content col-6 px-0">
              <h6 class="mb-0 ml-reset">전세대출</h6>
            </div>
            <div class="line_half_content col-6 px-0">
              <h6 class="ftw-400 mb-0 ml-reset">
                {{ loanYn }}
              </h6>
            </div>
          </div>
        </div>
      </div>

      <!-- 건축물 정보 -->

      <div id="section2">
        <!-- 타이틀 -->
        <div class="section_title">
          <h4>건축물 정보</h4>
          <el-tooltip
            placement="top-start"
            popper-class="jivpio_tooltip2"
            class="tooptip_style_1 jvo-impot"
          >
            <div slot="content">
              <p>
                건축물 주용도는 건축물대장, 정부와 공공기관이 공개한 자료를
                바탕으로 자동 입력됩니다. <br />(자료의 기준시점에 따라 일치하지
                않을 수 있습니다.) <br />집비오의 매물유형은 주용도에 따라
                아파트, 빌라, 주택 <br />으로 카테고리가 자동 분류됩니다.
              </p>
              <table>
                <tr>
                  <th>집비오 분류</th>
                  <th class="jipvio-text-center">건축물 세부용도</th>
                  <th>건축물용도(건축법)</th>
                </tr>
                <tr>
                  <td>아파트</td>
                  <td>아파트</td>
                  <td>공동주택</td>
                </tr>
                <tr>
                  <td>빌라</td>
                  <td>다세대,연립</td>
                  <td>공동주택</td>
                </tr>
                <tr>
                  <td>주택</td>
                  <td>단독,다중,다가구</td>
                  <td>단독주택</td>
                </tr>
                <tr>
                  <td>오피스텔</td>
                  <td>업무시설(오피스텔)</td>
                  <td>업무시설</td>
                </tr>
                <tr>
                  <td>원룸</td>
                  <td>정의되어 있지 않음</td>
                  <td>정의되어 있지 않음</td>
                </tr>
              </table>
            </div>
            <i class="fas fa-exclamation-circle"></i>
          </el-tooltip>
        </div>
        <!-- 1번 줄 -->
        <div class="row ml-0 mr-0 line">
          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half">
            <div class="line_half_content col-6 px-0 mx-w1">
              <h6 class="mb-0">건축물용도</h6>
            </div>
            <div class="line_half_content col-6 px-0 row mx-w2">
              <h6 class="ftw-400 mb-0">
                {{
                  pptDetailInfo.purp != null
                    ? sessionCoCodeMapDetail.BLP[pptDetailInfo.purp].name
                    : ""
                }}
              </h6>
            </div>
          </div>
          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half">
            <div class="line_half_content col-6 px-0">
              <h6 class="mb-0 ml-reset">건축물 주용도</h6>
            </div>
            <div class="line_half_content col-6 px-0">
              <h6 class="ftw-400 mb-0 ml-reset">
                {{ pptDetailInfo.mainPurp }}
              </h6>
            </div>
          </div>

          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half">
            <div class="line_half_content col-6 px-0">
              <h6 class="mb-0">총 세대수</h6>
            </div>
            <div class="line_half_content col-6 px-0">
              <h6 class="ftw-400 mb-0">
                {{ pptDetailInfo.householdCnt }} 세대
              </h6>
            </div>
          </div>
          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half">
            <div class="line_half_content col-6 px-0">
              <h6 class="mb-0 ml-reset">총 주차수</h6>
            </div>
            <div class="line_half_content col-6 px-0">
              <h6 class="ftw-400 mb-0 ml-reset">
                {{ pptDetailInfo.parkingCnt }} 대
              </h6>
            </div>
          </div>

          <!-- 2번 줄 -->
          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half">
            <div class="line_half_content col-6 px-0 mx-w1">
              <h6 class="mb-0">사용승인일자</h6>
            </div>
            <div class="line_half_content col-6 px-0 row mx-w2">
              <h6 class="ftw-400 mb-0">{{ useAprDay }}</h6>
            </div>
          </div>
          <div class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half">
            <div class="line_half_content col-6 px-0">
              <h6 class="mb-0 ml-reset">용도지역</h6>
            </div>
            <div class="line_half_content col-6 pl-0">
              <h6 class="ftw-400 mb-0 ml-reset">
                {{ addComma(pptDetailInfo.districtPurpList) }}
              </h6>
            </div>
          </div>

          <div
            class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half border-ctl"
          >
            <div class="line_half_content col-6 px-0">
              <h6 class="mb-0">대지면적</h6>
            </div>
            <div class="line_half_content col-6 px-0">
              <h6 class="ftw-400 mb-0">{{ pptDetailInfo.platArea }} ㎡</h6>
            </div>
          </div>
          <div
            class="row ml-0 mr-0 p-0 col-xl-3 col-md-4 col-6 line_half border-ctl"
          >
            <div class="line_half_content col-6 px-0">
              <h6 class="mb-0 ml-reset">연면적</h6>
            </div>
            <div class="line_half_content col-6 px-0">
              <h6 class="ftw-400 mb-0 ml-reset">
                {{ pptDetailInfo.totArea }} ㎡
              </h6>
            </div>
          </div>
        </div>
      </div>

      <!-- 옵션 -->
      <diV id="section3">
        <!-- 타이틀 -->
        <div class="section_title">
          <h4>옵션</h4>
        </div>
        <!-- 아이콘 -->
        <div class="option">
          <div v-for="bio in pptDetailInfo.builtinOptList" :key="bio.code">
            <i :class="bio.remark" :title="bio.name"></i>
            <p>{{ bio != null ? bio.name : "" }}</p>
          </div>
          <!-- <div>
            <i :class="petYn" :title="petYnT"></i>
            <p>{{ petYnT }}</p>
          </div> -->
        </div>
      </diV>

      <!-- 보안시설 -->
      <div id="section4">
        <!-- 타이틀 -->
        <div class="section_title">
          <h4>보안시설</h4>
        </div>
        <!-- 아이콘 -->
        <div class="option">
          <div v-for="bio in pptDetailInfo.securityOptList" :key="bio.code">
            <i :class="bio.remark" :title="bio.name"></i>
            <p>{{ bio != null ? bio.name : "" }}</p>
          </div>
        </div>
      </div>

      <!-- 위치 -->
      <div id="section5">
        <!-- 타이틀 -->
        <div class="section_title2">
          <h4>위치</h4>
          <el-tooltip
            effect="dark"
            placement="top-start"
            popper-class="jivpio_tooltip3"
            class="tooptip_style_2 jvo-impot"
          >
            <div slot="content">
              <p>
                <strong
                  >* 공인중개사법 제18조의2(중개대상물의 표시·광고)<br />
                  개정안에 의거하여 의뢰인이 원치 않으실 경우,</strong
                ><br />
                다음과 같이 정보를 공개합니다.
              </p>
              <p>
                1. 단독주택의 경우 지번을 읍․면․동․리까지 표시 가능<br />
                2. 공동주택의 경우 층을 저중고 로 대체 가능
              </p>
            </div>
            <i class="fas fa-exclamation-circle"></i>
          </el-tooltip>
          <p>소재지: {{ pptDetailInfo.addr }}</p>
        </div>

        <div id="DT_RV_Map_container" style="position: relative">
          <div id="DT_RVMapWrap">
            <div id="DT_roadview" style="width: 100%; height: 100%"></div>
            <div id="DT_rv_close" title="로드뷰닫기" @click="closeRoadview()">
              <span class="img"></span>
            </div>
          </div>
          <!-- "-->
          <div id="DT_MapWrap" class="detailMapWrap">
            <div
              class="detailMapInner"
              style="width: 100%; height: 100%"
              id="DT_Map"
              align="right"
            ></div>
            <div id="DT_rvControl" @click="setRoadviewRoad()"></div>
          </div>
        </div>
      </div>

      <!-- chart -->
      <div id="section6">
        <!-- 타이틀 -->
        <div class="section_title2 mt-20">
          <h4>실거래가</h4>
        </div>
        <div class="row">
          <div class="col-md-7 col-sm-6">
            <card class="card-chart" no-footer-line>
              <template slot="header">
                <h5 class="card-category jipvio-text-right">단위: 만원</h5>
              </template>
              <div class="chart-area">
                <line-chart
                  :labels="linechartdata.labels"
                  :data="linechartdata.data"
                  :color="linechartdata.color"
                  :title="linechartdata.title"
                  :extraOptions="linechartdata.extraOptions"
                  :height="400"
                >
                </line-chart>
              </div>
              <!-- <line-chart :chart-data="linechartdata"></line-chart> -->
            </card>
          </div>
          <div class="col-md-5 col-sm-6">
            <card class="card-chart" no-footer-line>
              <template slot="header">
                <h5 class="card-category jipvio-text-right">단위: 만원</h5>
              </template>
              <div class="chart-area">
                <bar-chart
                  :labels="barchartdata.labels"
                  :data="barchartdata.data"
                  :color="barchartdata.color"
                  :extraOptions="barchartdata.extraOptions"
                  :height="400"
                >
                </bar-chart>
              </div>
            </card>
            <!-- <bar-chart
              :labels="barchartdata.labels"
              :chart-data="barchartdata"
              :height="200"
            >
            </bar-chart> -->
            <!-- <input type="button" value="클릭" @click="changeData()" /> -->
          </div>
        </div>
      </div>

      <div class="" id="section7">
        <div class="section_title2 mt-50 mb-20 jipvio-text-center">
          <h4 class="">VR로 보는 구로구의 하루</h4>
        </div>
        <div class="mb-10">
          <iframe
            width="100%"
            src="https://www.youtube.com/embed/W167XnFDP_o"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div class="row m-row">
          <div class="col-12 px-0 mt-40">
            <h4 class="section_title2 jipvio-text-center">
              집비오에서 알려드리는 동네정보
            </h4>
          </div>
          <div class="col-lg-6 mt-10 mb-10 vill-info-video">
            <h4 class="jipvio-text-left">
              <i class="jipvio-ui-icons-pet"></i> 우리 댕댕이를 위한 합법적
              오프리쉬
            </h4>
            <p class="jipvio-text-left">
              구로구에 있는 합법적 오프리쉬를 위한 반려견 놀이터를 소개합니다.
              안전수칙을 지키며 반려견과 건강한 생활을 즐기세요.
            </p>
            <iframe
              width="100%"
              src="https://www.youtube.com/embed/zQq9IhOBIXQ"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div class="col-lg-6 mt-10 mb-10 vill-info-video">
            <h4 class="jipvio-text-left">
              <i class="jipvio-ui-icons-bowl"></i> 뜨근~한 국밥 한 그릇이
              땡긴다면
            </h4>
            <p class="jipvio-text-left" style="letter-spacing: -0.5px">
              가성비 훌륭한 국밥을 먹을 수 있는 곳, 구로구에서 가장 오래된
              재래시장인 구로시장과 남구로시장을 소개합니다. 이국적인 풍경과
              전통 시장의 풍경을 고루 경험할 수 있습니다.
            </p>
            <iframe
              width="100%"
              src="https://www.youtube.com/embed/LcxfmMY204o"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div class="col-lg-6 mt-10 mb-10 vill-info-video">
            <h4 class="jipvio-text-left">
              <i class="el-icon-brush"></i> 도시의 예술가들과 마주치고 싶다면
            </h4>
            <p class="jipvio-text-left">
              도림천과 어린이공원 부근을 걷다 보면 거리의 예술가들과 마주칠 수
              있습니다. 붓글씨를 써내려가는 어르신, 도림천 다리 밑 연주자들은
              평범한 산책에 재미를 더해줍니다.
            </p>
            <iframe
              width="100%"
              src="https://www.youtube.com/embed/JoKgjnXLkvE"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div class="col-lg-6 mt-10 mb-10 vill-info-video">
            <h4 class="jipvio-text-left">
              <i class="jipvio-ui-icons-footprint_2"></i> 도심에 숨겨진 보물, 안양천과 거리공원
            </h4>
            <p class="jipvio-text-left">
              도심 속에 숨어 있는 산책 맛집, 안양천과 거리공원을 소개합니다.
              자전거나 배드민턴채를 챙겨 가시는 걸 추천합니다.
            </p>
            <iframe
              width="100%"
              src="https://www.youtube.com/embed/B45xC9SnbTc"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div class="col-lg-6 mt-10 mb-50 vill-info-video">
            <h4 class="jipvio-text-left">
              <i class="fas fa-map-signs"></i> 올레길이 구로에도 있다고?
            </h4>
            <p class="jipvio-text-left">
              집 앞에서 시작해서 집 앞으로 끝나는 구로 올레길 코스를 소개합니다.
              낮고 완만한 산길을 지나 이색적인 철길과 도시 속 수목원을
              거닐어보세요.
            </p>
            <iframe
              width="100%"
              src="https://www.youtube.com/embed/M5pboOmrC_Q"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
      <!-- <div class="jipvio_button button_hide">
        <el-button round>문의하기</el-button>
      </div> -->
    </div>
    <!-- <Carouseloverlay
      :showOverlay="carouseloverlay"
      :carslImgs="showGeneralImages ? G_imgUrlList : TH_imgUrlList"
    >
      <el-button class="close_btn" @click="carouseloverlay" circle
        ><i class="el-icon-close"></i
      ></el-button>
      <div class="row mr-0 ml-0 px-0">
        <el-button class="col-6 px-0" @click="tag(0)">
          일반 이미지
        </el-button>
        <el-button class="col-6 ml-0 px-0" @click="tag(1)">
          열화상 이미지
        </el-button>
      </div>
    </Carouseloverlay> -->

    <div class="overlayTest" v-show="carouseloverlay">
      <div class="overlayTestInner">
        <el-carousel
          v-show="showGeneralImages"
          trigger="click"
          :interval="0"
          ref="carousel4"
          arrow="always"
        >
          <ul v-for="iu in carslImg" :key="iu.index">
            <el-carousel-item v-if="hasOwnPropertyByGeneral(iu)" name="index">
              <el-image :src="iu.gimgFileUrl"> </el-image>
            </el-carousel-item>
          </ul>
        </el-carousel>
        <el-carousel
          v-show="!showGeneralImages"
          trigger="click"
          :interval="0"
          ref="carousel3"
          arrow="always"
        >
          <ul v-for="iu in carslImg" :key="iu.index">
            <el-carousel-item v-if="hasOwnProperty(iu)" name="index">
              <el-image :src="iu.thImgFileUrl"> </el-image>
            </el-carousel-item>
          </ul>
        </el-carousel>
        <div class="row mr-0 ml-0 px-0">
          <el-button class="col-6 px-0" @click="tag(0)">
            일반 이미지
          </el-button>
          <el-button class="col-6 ml-0 px-0" @click="tag(1)">
            열화상 이미지
          </el-button>
        </div>
        <el-button class="close_btn" @click="overlay" circle
          ><i class="el-icon-close"></i
        ></el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { Pano } from "vuejs-vr";

import openApi from "@/service/openapi";
import propApi from "@/service/property";

import LineChart from "@/pages/Charts/LineChart.js";
import BarChart from "@/pages/Charts/BarChart.js";
import JipvioVR from "@/pages/components/Jipvio/VrViewer.vue";
import Carouseloverlay from "@/pages/components/Jipvio/ImageOverlay.vue";

import {
  Tooltip,
  Table,
  TableColumn,
  Button,
  Carousel,
  CarouselItem,
  Loading,
  Image
} from "element-ui";
import { Card } from "@/components";

import { createNamespacedHelpers } from "vuex";

const {
  mapGetters: sessionMapGetters
  //mapActions: sessionMapActions
} = createNamespacedHelpers("loginSession"); // mapping loginSession module

export default {
  bodyClass: "" /*sohyun이가 지움*/,
  components: {
    LineChart,
    BarChart,
    Card,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
    [Loading.name]: Loading,
    [Image.name]: Image,
    Pano,
    JipvioVR,
    Carouseloverlay
  },

  data() {
    return {
      loading: true,
      showCarsl: true,
      // kakao map
      overlayOn: null,
      marker: null,
      srRvMapContainer: null,
      srcList: [
        "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg"
      ],
      // chart Test Data
      linechartdata: {
        color: "#5a2fca",
        title: "Active Countries",
        extraOptions: {
          scales: {
            yAxes: [
              {
                scaleLabel: {
                  display: true
                },
                gridLines: {
                  zeroLineColor: "transparent",
                  drawBorder: false,
                  borderDash: [5, 5]
                }
              }
            ],
            xAxes: [
              {
                gridLines: {
                  zeroLineColor: "transparent",
                  drawTicks: false,
                  display: false,
                  drawBorder: false
                }
              }
            ]
          }
        }
      },
      barchartdata: {
        color: "#5a2fca",
        extraOptions: {
          scales: {
            yAxes: [
              {
                gridLines: {
                  zeroLineColor: "transparent",
                  drawBorder: false,
                  borderDash: [5, 5]
                }
              }
            ],
            xAxes: [
              {
                gridLines: {
                  zeroLineColor: "transparent",
                  drawTicks: false,
                  display: false,
                  drawBorder: false
                }
              }
            ]
          }
        }
        //labels:[]
        //data:[]
        //mixin chartData로 이용할 때 datasets이 필요함
        // datasets: [
        //   {
        //     label: "보증금",
        //     backgroundColor: "rgba(255, 99, 132, 0.2)",
        //     borderColor: "pink",
        //     borderWidth: 1,
        //     data: [80, 99, 86, 96, 123, 85, 100, 75, 88, 90, 123, 155]
        //   }
        // ]
      },
      deposit: [],
      len: [],

      carslImg: [],
      myTestList: [],
      G_imgUrlList: [],
      TH_imgUrlList: [],
      vrImgUrlList: "/img/ghost_home_bk.png",

      pptDetailInfo: {
        addr: null,
        balconyYn: null,
        berandaYn: null,
        builtinOptIds: null,
        builtinOptList: null,
        securityoptList: null,
        contract: {
          brokePrice: null,
          brokeRate: null,
          clientAddr: null,
          clientBirthDate: null,
          clientContactNum: null,
          clientName: null,
          deposit: null,
          etc: null,
          expireDate: null,
          extraFee: null,
          id: null,
          payment: null,
          paymentTypeId: null,
          propId: null,
          provInfoYn: null,
          regulation: null,
          relation: null,
          typeId: null
        },
        districtPurpCds: null,
        dong: null,
        eleYn: null,
        entTypeId: null,
        floor: null,
        heatingFuelTypeId: null,
        heatingTypeId: null,
        ho: null,
        householdCnt: null,
        lat: null,
        legalCode: null,
        lng: null,
        loanYn: null,
        moveDt: null,
        mtncFee: null,
        mtncIds: null,
        mtncList: null,
        newAddr: null,
        ownerAuthProviderId: null,
        ownerId: null,
        parkingCnt: null,
        platArea: null,
        proArea: null,
        propId: null,
        purpsCd: null,
        roomCnt: null,
        story: null,
        strctCd: null,
        totArea: null,
        typeId: null,
        updatedDate: null,
        upldFileIds: null,
        useAprDay: null,
        useArea: null,
        useIds: null,
        useList: null,
        wroomCnt: null
      },

      jipvioMarkers: [],
      customOverlay: [],
      RVMap: null,
      jipvioMap: null,
      jipvioGeocoder: null,
      jipvioRV: null,
      jipvioRV_Client: null,

      clsfData: [
        {
          clsfByJv: "아파트",
          purpsDetail: "아파트",
          purps: "공동주택"
        },
        {
          clsfByJv: "빌라",
          purpsDetail: "다세대, 연립",
          purps: "공동주택"
        },
        {
          clsfByJv: "주택",
          purpsDetail: "단독, 다중, 다가구",
          purps: "단독주택"
        },
        {
          clsfByJv: "오피스텔",
          purpsDetail: "업무시설(오피스텔)",
          purps: "업무시설"
        },
        {
          clsfByJv: "원룸",
          purpsDetail: "정의되어 있지 않음",
          purps: "정의되어 있지 않음"
        }
      ],

      options: [
        {
          id: 1,
          icon: "fas fa-video",
          name: "카메라"
        },
        {
          id: 2,
          icon: "fas fa-eye",
          name: "눈"
        },
        {
          id: 3,
          icon: "fas fa-eye",
          name: "눈"
        },
        {
          id: 4,
          icon: "fas fa-eye",
          name: "눈"
        },
        {
          id: 5,
          icon: "fas fa-eye",
          name: "눈"
        }
      ],

      VRindex: 0,
      Area: true,
      showGeneralImages: true,
      carouseloverlay: false //이미지 카로셀 오버레이//
    };
  },
  created() {
    this.changeCarslType();
    window.addEventListener("resize", this.changeCarslType);
    // this.hasOwnPropertyByGeneral();
    // this.hasOwnProperty();
  },
  destroyed() {
    window.addEventListener("resize", this.changeCarslType);
  },

  mounted() {
    if (window.kakao && window.kakao.maps) {
      this.initMap();
    } else {
      const script = document.createElement("script");
      /* global kakao */
      const serviceKey = process.env.VUE_APP_KKO_SDK_KEY;

      script.onload = () => kakao.maps.load(this.initMap);

      script.src = `https://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=${serviceKey}&libraries=services`;
      // <head></head>에 위치
      document.head.appendChild(script);
    }
  },

  watch: {},

  computed: {
    ...sessionMapGetters({
      sessionCoCodeMapDetail: "getCoCodeMapDetail"
    }),
    //2억 5,900만 원 / 9,000만 원

    parkingYn() {
      if (this.pptDetailInfo.parkingCnt > 0) {
        return "가능";
      } else {
        return "불가능";
      }
    },
    eleYn() {
      if (this.pptDetailInfo.eleYn == true) {
        return "있음";
      } else {
        return "없음";
      }
    },

    useFeeYn() {
      if (
        this.pptDetailInfo.useList != null &&
        this.pptDetailInfo.useList.length > 0
      ) {
        return "있음";
      } else {
        return "없음";
      }
    },

    verandaYn() {
      if (this.pptDetailInfo.berandaYn == true) {
        return "있음";
      } else {
        return "없음";
      }
    },

    balconyYn() {
      if (this.pptDetailInfo.balconyYn == true) {
        return "있음";
      } else {
        return "없음";
      }
    },

    loanYn() {
      if (this.pptDetailInfo.loanYn == true) {
        return "가능";
      } else {
        return "불가능";
      }
    },

    mtncList() {
      let mtncL = "";
      const OriginMtncL = this.pptDetailInfo.mtncList;
      if (OriginMtncL == null) {
        return null;
      } else if (OriginMtncL.length == 1) {
        return OriginMtncL[0].name;
      } else {
        for (var i = 0; i < OriginMtncL.length - 1; i++) {
          mtncL = mtncL + OriginMtncL[i].name + ",";
        }
        return mtncL + OriginMtncL[OriginMtncL.length - 1].name;
      }
    },

    useList() {
      let useL = "";
      const OriginUseL = this.pptDetailInfo.useList;

      if (OriginUseL == null) {
        return null;
      } else if (OriginUseL.length == 1) {
        return OriginUseL[0].name;
      } else {
        for (var i = 0; i < OriginUseL.length - 1; i++) {
          useL = useL + OriginUseL[i].name + ",";
        }
        return useL + OriginUseL[OriginUseL.length - 1].name;
      }
    },

    pptTitleForMap() {
      const deposit = "전세" + this.pptDetailInfo.deposit + "원";
      const area = "면적" + this.pptDetailInfo.useArea + "m²";
      const roomCnt = "방" + this.pptDetailInfo.roomCnt + "개";

      return deposit + "\n" + area + "\n" + roomCnt;
    },
    useAprDay() {
      if (this.pptDetailInfo.useAprDay != null) {
        return this.pptDetailInfo.useAprDay.substr(0, 10);
      } else {
        return null;
      }
    },
    supplyAreaP() {
      return Math.round(this.pptDetailInfo.proArea * 0.3025);
    },

    useAreaP() {
      return Math.round(this.pptDetailInfo.useArea * 0.3025);
    },
    mvDateShow() {
      return this.$moment(this.pptDetailInfo.moveDt).format("YYYY-MM-DD");
    }
  },

  methods: {
    //카로셀 오버레이//
    overlay() {
      console.log("=======overlay");
      this.carouseloverlay = !this.carouseloverlay;
      let index = this.$refs.carousel.activeIndex;
      let index2 = this.$refs.carousel2.activeIndex;
      this.$refs.carousel3.setActiveItem(index);
      this.$refs.carousel4.setActiveItem(index2);
    },

    /* 모바일 일반이미지 카로셀 오버레이 */
    overlay2() {
      console.log("=======overlay2");
      this.tag(0);
      this.carouseloverlay = !this.carouseloverlay;
      let index = "";
      switch (this.$refs.carousel5.activeIndex) {
        case 0:
          index = 0;
          break;
        case 2:
          index = 1;
          break;
        case 4:
          index = 2;
          break;
        case 6:
          index = 3;
          break;
        case 8:
          index = 4;
          break;
        case 10:
          index = 5;
          break;
        case 12:
          index = 6;
          break;
        case 14:
          index = 7;
          break;
        case 16:
          index = 8;
          break;
        case 18:
          index = 9;
      }
      this.$refs.carousel3.setActiveItem(index);
      this.$refs.carousel4.setActiveItem(index);
    },
    /* 모바일 열화상이미지 카로셀 오버레이 */
    overlay3() {
      console.log("=======overlay3");
      this.tag(1);
      this.carouseloverlay = !this.carouseloverlay;
      let index = "";
      switch (this.$refs.carousel5.activeIndex) {
        case 1:
          index = 0;
          break;
        case 3:
          index = 1;
          break;
        case 5:
          index = 2;
          break;
        case 7:
          index = 3;
          break;
        case 9:
          index = 4;
          break;
        case 11:
          index = 5;
          break;
        case 13:
          index = 6;
          break;
        case 15:
          index = 7;
          break;
        case 17:
          index = 8;
          break;
        case 19:
          index = 9;
      }
      this.$refs.carousel3.setActiveItem(index);
      this.$refs.carousel4.setActiveItem(index);
    },

    onLoad() {
      console.log("======hi");
      this.loading = false;
      console.log(this.loading);
    },
    onFail() {
      console.log("=======hi2");
    },
    nextVR() {
      if (this.pptDetailInfo.vrImgFileUrlList.length > 1) {
        if (this.pptDetailInfo.vrImgFileUrlList.length - 1 == this.VRindex) {
          this.VRindex = 0;
        } else {
          this.loading = true;
          this.VRindex++;
        }
      }
    },
    prevVR() {
      if (this.pptDetailInfo.vrImgFileUrlList.length > 1) {
        if (this.VRindex == 0) {
          this.VRindex = this.pptDetailInfo.vrImgFileUrlList.length - 1;
        } else {
          this.loading = true;
          this.VRindex--;
        }
      }
    },
    depositM() {
      const depositVal =
        this.pptDetailInfo.deposit < 0 ? false : this.pptDetailInfo.deposit;

      const unitWords = ["원", "만"];
      const splitUnit = 10000;
      const splitCount = unitWords.length;
      let resultArray = [];
      let resultString = "";

      if (depositVal < 100000000) {
        for (let i = 0; i < splitCount; i++) {
          var unitResult =
            (depositVal % Math.pow(splitUnit, i + 1)) / Math.pow(splitUnit, i);
          unitResult = Math.floor(unitResult);
          if (unitResult > 0) {
            resultArray[i] = unitResult;
          }
        }
        for (var i = 0; i < resultArray.length; i++) {
          if (!resultArray[i]) continue;
          resultString = String(resultArray[i]) + unitWords[i] + resultString;
        }

        return resultString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return depositVal / 100000000 + "억";
      }
    },
    /* ==================================카카오 맵 */
    toggleRoadview(position) {
      const self = this;
      this.jipvioRV_Client.getNearestPanoId(position, 50, function(panoId) {
        // 파노라마 ID가 null 이면 로드뷰를 숨깁니다
        if (panoId === null) {
          self.toggleMapWrapper(true, position);
        } else {
          self.toggleMapWrapper(false, position);

          // panoId로 로드뷰를 설정합니다
          self.jipvioRV.setPanoId(panoId, position);
        }
      });
    },

    // 지도를 감싸고 있는 div의 크기를 조정하는 함수입니다
    toggleMapWrapper(active, position) {
      if (active) {
        // 지도를 감싸고 있는 div의 너비가 100%가 되도록 class를 변경합니다
        document.getElementById("DT_RVMapWrap").className = "";

        // 지도의 크기가 변경되었기 때문에 relayout 함수를 호출합니다
        this.jipvioMap.relayout();

        // 지도의 너비가 변경될 때 지도중심을 입력받은 위치(position)로 설정합니다
        this.jipvioMap.setCenter(position);
      } else {
        // 지도만 보여지고 있는 상태이면 지도의 너비가 50%가 되도록 class를 변경하여
        // 로드뷰가 함께 표시되게 합니다
        if (
          document
            .getElementById("DT_RVMapWrap")
            .className.indexOf("view_roadview") === -1
        ) {
          document.getElementById("DT_RVMapWrap").className = "view_roadview";
          // 지도의 크기가 변경되었기 때문에 relayout 함수를 호출합니다
          this.jipvioMap.relayout();
          //   // 지도의 너비가 변경될 때 지도중심을 입력받은 위치(position)로 설정합니다
          this.jipvioMap.setCenter(position);
        }
      }
    },

    // 지도 위의 로드뷰 도로 오버레이를 추가,제거하는 함수입니다

    // 지도 위의 로드뷰 버튼을 눌렀을 때 호출되는 함수입니다

    // 로드뷰에서 X버튼을 눌렀을 때 로드뷰를 지도 뒤로 숨기는 함수입니다
    closeRoadview() {
      let position = this.marker.getPosition();
      this.toggleMapWrapper(true, position);
    },

    toggleOverlay(active) {
      if (active) {
        this.overlayOn = true;

        // 지도 위에 로드뷰 도로 오버레이를 추가합니다
        this.jipvioMap.addOverlayMapTypeId(kakao.maps.MapTypeId.ROADVIEW);

        // 지도 위에 마커를 표시합니다
        this.marker.setMap(this.jipvioMap);

        // 마커의 위치를 지도 중심으로 설정합니다
        this.marker.setPosition(this.jipvioMap.getCenter());

        // 로드뷰의 위치를 지도 중심으로 설정합니다
        this.toggleRoadview(this.jipvioMap.getCenter());
      } else {
        this.overlayOn = false;

        // 지도 위의 로드뷰 도로 오버레이를 제거합니다
        this.jipvioMap.removeOverlayMapTypeId(kakao.maps.MapTypeId.ROADVIEW);

        // 지도 위의 마커를 제거합니다
        this.marker.setMap(null);

        let position = this.marker.getPosition();
        this.toggleMapWrapper(true, position);
      }
    },
    setRoadviewRoad() {
      let control = document.getElementById("DT_rvControl");

      // 버튼이 눌린 상태가 아니면
      if (control.className.indexOf("active") === -1) {
        control.className = "active";

        // 로드뷰 도로 오버레이가 보이게 합니다
        this.toggleOverlay(true);
      } else {
        control.className = "";

        // 로드뷰 도로 오버레이를 제거합니다
        this.toggleOverlay(false);
      }
    },
    /* ==================================카카오 맵 */

    addUnit(value) {
      const divisionVal = value < 0 ? false : value;
      const unitWords = ["원", "만원", "억", "조", "경"];
      const splitUnit = 10000;
      const splitCount = unitWords.length;
      let resultArray = [];
      let resultString = "";

      for (var i = 0; i < splitCount; i++) {
        var unitResult =
          (divisionVal % Math.pow(splitUnit, i + 1)) / Math.pow(splitUnit, i);
        unitResult = Math.floor(unitResult);
        if (unitResult > 0) {
          resultArray[i] = unitResult;
        }
      }
      for (var i = 0; i < resultArray.length; i++) {
        if (!resultArray[i]) continue;
        resultString = String(resultArray[i]) + unitWords[i] + resultString;
      }

      return resultString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    addComma(value) {
      let List = "";
      const OrgingList = value;
      if (OrgingList != null) {
        if (OrgingList.length == 1) {
          return OrgingList[0];
        } else {
          for (var i = 0; i < OrgingList.length - 1; i++) {
            List = List + OrgingList[i] + ", ";
          }
          return List + OrgingList[OrgingList.length - 1];
        }
      } else {
        return null;
      }
    },

    /* 열화상,일반 tag */
    tag(type) {
      if (type == 0) {
        let index = this.$refs.carousel.activeIndex;
        let index2 = this.$refs.carousel3.activeIndex;
        this.showGeneralImages = true;
        this.$refs.carousel2.setActiveItem(index);
        this.$refs.carousel4.setActiveItem(index2);
        // this.carslImg = this.pptDetailInfo.G_imgUrlList;
      } else if (type == 1) {
        let index = this.$refs.carousel2.activeIndex;
        let index2 = this.$refs.carousel4.activeIndex;
        this.showGeneralImages = false;
        this.$refs.carousel.setActiveItem(index);
        this.$refs.carousel3.setActiveItem(index2);
        // this.carslImg = this.pptDetailInfo.THimgUrlList;
      }
    },
    /* 열화상,일반 유무확인 */
    hasOwnPropertyByGeneral(imgUrlObj) {
      // this.carslImg.forEach(ele => {
      //   this.carslImg.hasOwnProperty("gimgFileUrl")
      //     ? this.G_imgUrlList.push(ele.gimgFileUrl)
      //     : 0;
      // });
      return imgUrlObj.hasOwnProperty("gimgFileUrl") ? 1 : 0;
    },
    hasOwnProperty(imgUrlObj) {
      // this.carslImg.forEach(ele => {
      //   this.carslImg.hasOwnProperty("thImgFileUrl")
      //     ? this.TH_imgUrlList.push(ele.thImgFileUrl)
      //     : 0;
      // });
      return imgUrlObj.hasOwnProperty("thImgFileUrl") ? 1 : 0;
    },
    hasOwnProperty_G_TH(imgUrlObj) {
      return imgUrlObj.hasOwnProperty("gimgFileUrl") &&
        imgUrlObj.hasOwnProperty("thImgFileUrl")
        ? 1
        : 0;
    },

    /* 전용/공급면적 */
    toggleButton() {
      this.Area = !this.Area;
    },

    changeCarslType() {
      const browserWth = document.body.clientWidth;

      if (browserWth <= 1200) {
        this.showCarsl = false;
      } else {
        this.showCarsl = true;
      }
    },
    loadImage(idx, URL, retries = 5) {
      console.log("======LoadImage " + retries);
      img = new image();
      let self = this;
      img.onerror = () => {
        if (retries > 0) {
          console.log("=========Image load err");
          self.loadImage(idx, URL, retries - 1);
        } else {
          console.error("=========Image not found");
          //alert("image not found");
        }
      };
      img.src = URL;
      this.myTestList[idx] = img;
    },
    async getPropertyDetail(id) {
      const res = await propApi.getPropertyDetail(id);

      // let VRimgUrlList = res.payload.vrImgFileUrlList;

      // for (let i = 0; i < VRimgUrlList.length; i++) {
      //this.loadImage(i, VRimgUrlList[i]);
      // console.log("==123===");
      // var img = new Image();
      // img.onerror = () => {
      //   console.log("=======mytest");
      // }
      // img.src = VRimgUrlList[i];
      // VRimgUrlList[i] = img;
      // }
      // this.myTestList = VRimgUrlList;

      this.carslImg = res.payload.icPairInfoList;
      this.pptDetailInfo = res.payload;

      console.log("===loadsh");
      this.vrImgUrlList = res.payload.vrImgFileUrlList;

      // 전월세 실거래가 차트 데이터

      /* 반려동물 여부 */
      if (this.pptDetailInfo.petYn == true) {
        this.pptDetailInfo.builtinOptList.push({
          code: "PetYes",
          name: "반려동물가능",
          remark: "jipvio-ui-icons-pet_yes"
        });
      } else {
        this.pptDetailInfo.builtinOptList.push({
          code: "petNo",
          name: "반려동물불가능",
          remark: "jipvio-ui-icons-pet_no"
        });
      }

      this.getCharData();
    },

    async getCharData() {
      const response = await openApi.getAptRentData({
        dealDate: "202001",
        regionCode: 11320
        // regionCode: this.pptDetailInfo.legalCode.substr(0, 5)
      });

      const aptArray = response.payload.body.items;
      this.deposit = [];
      this.len = [];

      for (let i = 0; i < aptArray.length; i++) {
        this.deposit.push(Number(aptArray[i]["deposit"]));
        this.len.push(i);
      }

      this.linechartdata = {
        labels: [
          "1월",
          "2월",
          "3월",
          "4월",
          "5월",
          "6월",
          "7월",
          "8월",
          "9월",
          "10월",
          "11월",
          "12월"
        ],
        //labels: self.len,
        data: this.deposit
      };
      this.barchartdata = {
        labels: [
          "1월",
          "2월",
          "3월",
          "4월",
          "5월",
          "6월",
          "7월",
          "8월",
          "9월",
          "10월",
          "11월",
          "12월"
        ],
        // labels: self.len,
        data: this.deposit
      };
    },

    async initMap() {
      const self = this;

      this.overlayOn = false; // 지도 위에 로드뷰 오버레이가 추가된 상태를 가지고 있을 변수
      this.srRvMapContainer = document.getElementById("DT_RV_Map_container");
      const srMapWrap = document.getElementById("DT_MapWrap"); // 지도를 감싸고 있는 div 입니다
      const srMap = document.getElementById("DT_Map");
      const rvContainer = document.getElementById("DT_roadview"); //로드뷰를 표시할 div 입니다

      await this.getPropertyDetail(this.$route.query.id);
      // const container = document.getElementById("SRMap");
      const options = {
        center: new kakao.maps.LatLng(
          this.pptDetailInfo.lat,
          this.pptDetailInfo.lng
        ),
        level: 3
      };

      // 지도를 표시할 div와 지도 옵션으로 지도를 생성합니다
      this.jipvioMap = new kakao.maps.Map(srMap, options);
      this.jipvioRV = new kakao.maps.Roadview(rvContainer);
      this.jipvioRV_Client = new kakao.maps.RoadviewClient();
      this.jipvioGeocoder = new kakao.maps.services.Geocoder();

      this.makeMarker();

      // 로드뷰에 좌표가 바뀌었을 때 발생하는 이벤트를 등록합니다
      kakao.maps.event.addListener(
        this.jipvioRV,
        "position_changed",
        function() {
          // 현재 로드뷰의 위치 좌표를 얻어옵니다
          let rvPosition = self.jipvioRV.getPosition();

          // 지도의 중심을 현재 로드뷰의 위치로 설정합니다
          self.jipvioMap.setCenter(rvPosition);

          // 지도 위에 로드뷰 도로 오버레이가 추가된 상태이면
          if (self.overlayOn) {
            // 마커의 위치를 현재 로드뷰의 위치로 설정합니다
            self.marker.setPosition(rvPosition);
          }
        }
      );

      // // 마커를 생성합니다
      // new kakao.maps.Marker({
      //   map: this.jipvioMap, // 마커를 표시할 지도
      //   position: new kakao.maps.LatLng(
      //     this.pptDetailInfo.lat,
      //     this.pptDetailInfo.lng
      //   ), // 마커를 표시할 위치
      //   title: this.pptTitleForMap
      // });

      // 마커 이미지를 생성합니다
      let markImage = new kakao.maps.MarkerImage(
        "https://t1.daumcdn.net/localimg/localimages/07/2018/pc/roadview_minimap_wk_2018.png",
        new kakao.maps.Size(26, 46),
        {
          // 스프라이트 이미지를 사용합니다.
          // 스프라이트 이미지 전체의 크기를 지정하고
          spriteSize: new kakao.maps.Size(1666, 168),
          // 사용하고 싶은 영역의 좌상단 좌표를 입력합니다.
          // background-position으로 지정하는 값이며 부호는 반대입니다.
          spriteOrigin: new kakao.maps.Point(705, 114),
          offset: new kakao.maps.Point(13, 46)
        }
      );

      // 드래그가 가능한 마커(로드 뷰)를 생성합니다
      this.marker = new kakao.maps.Marker({
        image: markImage,
        position: new kakao.maps.LatLng(
          this.$route.query.y,
          this.$route.query.x
        ),
        draggable: true
      });

      // 마커에 dragend 이벤트를 등록합니다
      kakao.maps.event.addListener(this.marker, "dragend", function(
        mouseEvent
      ) {
        // 현재 마커가 놓인 자리의 좌표입니다
        let position = self.marker.getPosition();

        // 마커가 놓인 위치를 기준으로 로드뷰를 설정합니다
        self.toggleRoadview(position);
      });

      //지도에 클릭 이벤트를 등록합니다
      kakao.maps.event.addListener(this.jipvioMap, "click", function(
        mouseEvent
      ) {
        // 지도 위에 로드뷰 도로 오버레이가 추가된 상태가 아니면 클릭이벤트를 무시합니다
        if (!self.overlayOn) {
          return;
        }

        // 클릭한 위치의 좌표입니다
        let position = mouseEvent.latLng;

        // 마커를 클릭한 위치로 옮깁니다
        self.marker.setPosition(position);

        // 클락한 위치를 기준으로 로드뷰를 설정합니다
        self.toggleRoadview(position);
      });

      // 전달받은 좌표(position)에 가까운 로드뷰의 파노라마 ID를 추출하여
      // 로드뷰를 설정하는 함수입니다

      //소현추가 줌인아웃, 로드뷰, 일반지도 추가하고싶음!!
      // 일반 지도와 스카이뷰로 지도 타입을 전환할 수 있는 지도타입 컨트롤을 생성합니다.
      const mapTypeControl = new kakao.maps.MapTypeControl();
      // 지도에 컨트롤을 추가해야 지도위에 표시됩니다
      // kakao.maps.ControlPosition은 컨트롤이 표시될 위치를 정의하는데 TOPRIGHT는 오른쪽 위를 의미합니다.
      this.jipvioMap.addControl(
        mapTypeControl,
        kakao.maps.ControlPosition.TOPRIGHT
      );

      // 지도 확대 축소를 제어할 수 있는  줌 컨트롤을 생성합니다.
      const zoomControl = new kakao.maps.ZoomControl();
      this.jipvioMap.addControl(zoomControl, kakao.maps.ControlPosition.RIGHT);
      //소현추가 끝
    },
    makeMarker() {
      const self = this;

      // 커스텀 오버레이에 표출될 내용으로 HTML 문자열이나 document element가 가능합니다

      function setContent() {
        const content =
          '<div class="BGimage" id="markerImage' +
          '">' +
          '<div class="Map_marker">' +
          "<div>" +
          '<h6 class="jipvio-color1 text-left" style="margin: 9px 0 6px 0; padding-left: 30px">' +
          self.sessionCoCodeMapDetail.BPP[self.pptDetailInfo.type].name +
          "</h6>" +
          "<ul>" +
          "<li>전세 <span>" +
          self.depositM() +
          "</span></li>" +
          "<li>면적 <span>" +
          self.pptDetailInfo.useArea +
          "㎡</span></li>" +
          "<li>방 <span>" +
          self.pptDetailInfo.roomCnt +
          "</span></li>" +
          "</ul>" +
          "</div>" +
          "</div>" +
          "</div>";

        return content;
      }

      var position = new kakao.maps.LatLng(
        this.pptDetailInfo.lat,
        this.pptDetailInfo.lng
      );

      let customOverlay = new kakao.maps.CustomOverlay({
        map: this.jipvioMap,
        position: new kakao.maps.LatLng(
          this.pptDetailInfo.lat,
          this.pptDetailInfo.lng
        ),
        content: setContent(),
        yAnchor: 1
      });
    },

    changeData() {
      this.barchartdata.data = [
        this.getRandomInt(),
        this.getRandomInt(),
        this.getRandomInt(),
        this.getRandomInt(),
        this.getRandomInt(),
        this.getRandomInt(),
        this.getRandomInt(),
        this.getRandomInt(),
        this.getRandomInt(),
        this.getRandomInt(),
        this.getRandomInt(),
        this.getRandomInt()
      ];
      this.linechartdata.data = [
        this.getRandomInt(),
        this.getRandomInt(),
        this.getRandomInt(),
        this.getRandomInt(),
        this.getRandomInt(),
        this.getRandomInt(),
        this.getRandomInt(),
        this.getRandomInt(),
        this.getRandomInt(),
        this.getRandomInt(),
        this.getRandomInt(),
        this.getRandomInt()
      ];
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    }
  }
};
</script>
<style>
#imageOb .vrpano_wrapper .v-pano {
  background-color: white !important;
}

div.features-1.property-detail .el-loading-mask {
  z-index: 1029;
}
/* roadview css 여기부터 */
.view_roadview {
  z-index: 10 !important;
}

#srRvMapContainer {
  overflow: hidden;
  /* height: 300px; */
  position: relative;
}
#DT_MapWrap {
  width: 100%;
  height: 75vh;
  z-index: 1;
}
#DT_RVMapWrap {
  width: calc(50% - 5vh);
  height: calc(50%);
  bottom: 0;
  left: 0;
  position: absolute;
  z-index: 0;
}

#srRvMapContainer.view_roadview #DT_MapWrap {
  width: 50%;
}

#DT_rvControl {
  position: absolute;
  top: 5px;
  left: 5px;
  width: 42px;
  height: 42px;
  z-index: 1;
  cursor: pointer;
  background: url(https://t1.daumcdn.net/localimg/localimages/07/2018/pc/common/img_search.png)
    0 -450px no-repeat;
}

#DT_rvControl.active {
  background-position: 0 -350px;
}
#DT_rv_close {
  position: absolute;
  padding: 4px;
  top: 5px;
  left: 5px;
  cursor: pointer;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #c8c8c8;
  box-shadow: 0px 1px #888;
}
#DT_rv_close .img {
  display: block;
  background: url(https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/rv_close.png)
    no-repeat;
  width: 14px;
  height: 14px;
}
/* roadview css 여기까지 */

/* VR 관련 css */
div.vrpano_wrapper {
  height: 500px;
  margin-top: 16px;
}
/* VR 전/후 버튼 */
.prevBtn,
.nextBtn {
  position: absolute;
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  height: 36px;
  width: 36px;
  cursor: pointer;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  border-radius: 50%;
  background-color: rgba(31, 45, 61, 0.11);
  color: #fff;
  position: absolute;
  top: 50%;
  z-index: 10;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  text-align: center;
  font-size: 12px;
  /* display: none; */
}
.prevBtn {
  left: 30px;
}
.nextBtn {
  right: 30px;
}
/* .v-pano:hover ~ .prevBtn {
  display: block;
}
.v-pano:hover ~ .nextBtn {
  display: block;
} */

div.overlayTest {
  position: fixed;
  z-index: 999999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #000000c0;
}
/*PC Fullscreen*/
#carousel_fullscreen {
  position: absolute;
  bottom: 38px;
  right: 15px;
  border: none;
  background-color: #ffffff00;
  z-index: 2;
}
#carousel_fullscreen i {
  font-size: 18px;
  color: #ffffff;
  font-weight: bold;
}
/*Mobile Fullscreen*/
#m_carousel_fullscreen {
  position: absolute;
  bottom: 0px;
  right: 0px;
  border: none;
  background-color: #ffffff00;
  z-index: 2;
}
#m_carousel_fullscreen i {
  font-size: 24px;
  color: #5a2fca;
  font-weight: bold;
}
div.overlayTest .close_btn {
  position: absolute;
  top: 5%;
  right: 5%;
  z-index: 10;
}
div.overlayTestInner {
  width: 70%;
  height: 90vh;
  margin: 0 auto;
  margin-top: 10vh;
}
div.overlayTestInner .el-carousel {
  width: 100%;
  height: 85%;
}
div.overlayTestInner .el-carousel__container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
div.overlayTestInner .el-carousel__item:nth-child(2n + 1) {
  background-color: #00000060;
}
div.overlayTestInner .el-image {
  width: 100%;
  height: 100%;
}
div.overlayTestInner .el-image img {
  object-fit: contain;
  height: 100%;
}

/* 마커 css */
.BGimage {
  background: url(/img/jip_icons/jipvio-marker-pin.png) no-repeat;
  background-size: cover;
  width: 137px;
  height: 127px;
  position: absolute;
  top: -72px;
  left: -27px;
}
/* 마커 css 끝 */

div.property-detail li {
  list-style-type: none;
}
.ftw-400 {
  font-weight: 400;
}
.line_half .mx-w1 {
  flex: 0 0 43%;
  max-width: 43%;
}

.line_half .mx-w2 {
  flex: 0 0 57%;
  max-width: 57%;
}

.line_half .mx-w2 .mx-w2_1 {
  flex: 0 0 41%;
  max-width: 41%;
}
.line_half .mx-w2 .mx-w2_2 {
  flex: 0 0 59%;
  max-width: 59%;
}
/* 
.el-carousel__item {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
} */

.el-carousel__item .componentContainer {
  width: 100% !important;
  height: 100% !important;
}
.el-carousel__item .componentContainer button {
  padding: 1em;
}
#imageOb .el-carousel__button {
  width: 25px;
}
/* .el-carousel__item .componentContainer button div {
  display: none;
} */

.detailMapWrap {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #ddd;
}

.detailMapInner {
  position: absolute;
  top: 0;
  right: 0;
}

#imageOb i.jipvio-ui-icons-360_vr {
  position: absolute;
  top: -5px;
  right: 25px;
  color: #ffffff80;
  font-size: 5em;
}
/* button.webvr-ui-button.vrButton { */
/* display: none; */
/* } */

#imageOb img {
  object-fit: cover;
  height: 100%;
}

#imageOb .el-image {
  width: 100%;
  height: 100%;
}
#imageOb .el-image img {
  object-fit: cover;
  height: 100%;
}

#imageOb div:nth-of-type(1) .el-carousel__container,
#imageOb div:nth-of-type(2) .el-carousel__container {
  height: 500px;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

/* el-tooltip */
.tooptip_style_1,
.tooptip_style_2 {
  font-size: 20px;
}
.tooptip_style_2 {
  margin: 0 23px 0 26px;
}
.tooltip_P {
  padding-left: 13px;
}

.el-tooltip__popper[x-placement^="top-start"] .popper__arrow::after {
  border-top-color: #6a6a6a;
}
.el-tooltip__popper[x-placement^="top-start"] .popper__arrow {
  border-top-color: #6a6a6a;
}
.el-tooltip__popper[x-placement^="bottom-start"] .popper__arrow::after {
  border-bottom-color: #6a6a6a;
}
.el-tooltip__popper[x-placement^="bottom-start"] .popper__arrow {
  border-bottom-color: #6a6a6a;
}

.el-tooltip__popper.jivpio_tooltip1,
.el-tooltip__popper.jivpio_tooltip2,
.el-tooltip__popper.jivpio_tooltip3 {
  background: #6a6a6a !important;
  font-size: 1.1rem;
}
.el-tooltip__popper.jivpio_tooltip1,
.el-tooltip__popper.jivpio_tooltip3 {
  width: 393px;
}

.el-tooltip__popper.jivpio_tooltip2 {
  width: 379px;
}
.el-tooltip__popper.jivpio_tooltip2 div {
  padding: 7px 0;
}
.el-tooltip__popper.jivpio_tooltip1 div {
  padding: 7px 20px;
}
.el-tooltip__popper.jivpio_tooltip3 div {
  padding: 7px 20px 0 20px;
}
.el-tooltip__popper.jivpio_tooltip1 div p,
.el-tooltip__popper.jivpio_tooltip2 div p,
.el-tooltip__popper.jivpio_tooltip3 div p {
  font-size: 17px;
  letter-spacing: -0.09em;
  text-align: justify;
}

.el-tooltip__popper.jivpio_tooltip2 table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  letter-spacing: 0.07px;
}
.el-tooltip__popper.jivpio_tooltip2 table th,
.el-tooltip__popper.jivpio_tooltip2 table td {
  border: 1px solid #fff;
}
.el-tooltip__popper.jivpio_tooltip2 table th:nth-of-type(1),
.el-tooltip__popper.jivpio_tooltip2 table td:nth-of-type(1) {
  border-left: none;
}

.el-tooltip__popper.jivpio_tooltip2 table th:nth-of-type(3),
.el-tooltip__popper.jivpio_tooltip2 table td:nth-of-type(3) {
  border-right: none;
  padding-left: 9px;
}
.el-tooltip__popper.jivpio_tooltip2 table td:nth-of-type(2) {
  padding-left: 5px;
}

/* ============================================== */
.jipvio_title {
  margin-top: 20px;
  color: #4d4c4c;
}
.jipvio_title ul {
  width: 100%;
  height: 114px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.6em;
  font-weight: 600;
  position: relative;
}
.jipvio_title ul li {
  font-weight: normal;
  margin: 0 0.8vw;
}
/* .jipvio_title ul li:nth-of-type(2) {
  margin-right: 0 auto;
}
.jipvio_title ul li:nth-of-type(3) {
  margin-right: 85px;
} */
/* .jipvio_title ul li:nth-of-type(4) button {
  display: flex;
  align-items: center;
  padding-left: 26px;
} */

.jipvio_button button {
  background-color: #434343;
  font-size: 1rem;
  font-weight: bold;
  color: #fff;
  width: 118px;
  line-height: 14px;
}
.button_hide {
  margin: 102px 0;
}

.section_title {
  border-bottom: 1.2px solid #adadad;
  text-align: left;
  color: #797979;
  position: relative;
}

.section_title h4 {
  display: inline-block;
  margin-right: 9px;
  margin-bottom: 0;
  font-size: 1.7em;
  font-weight: bold;
}

.section_title h4 span {
  margin-left: 22px;
  font-size: 1.13rem;
  font-weight: 300;
}
.section_title .actions {
  display: inline-block;
  position: absolute;
  right: 28px;
  bottom: 3px;
}

.section_title .actions li {
  cursor: pointer;
}
.section_title .actions li i {
  font-size: 1.4em;
}

.section_title2 {
  text-align: left;
  color: #797979;
  font-weight: bold;
}

.section_title2 h4,
.section_title2 p {
  display: inline-block;
}
.section_title2 h4 {
  font-size: 2em;
  font-weight: bold;
}
h4.section_title2 {
  font-size: 2em;
  font-weight: bold;
}
#section6 .card {
  box-shadow: none;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
#section7 div iframe {
  height: 618px;
}
#section7 div.vill-info-video iframe {
  height: 430px;
}
#section7 div.vill-info-video h4 {
  font-weight: 600;
}
#section7 div.vill-info-video p {
  min-height: 80px;
  font-weight: 400;
  color: #494949;
}
/*실거래가 그래프*/
h5.card-category.jipvio-text-right {
  padding-right: 5px;
  padding-top: 3px;
}
/* 표 틀잡기 */
.line {
  font-size: 1.4em;
}

.line .line_half {
  color: #888888;
  border-bottom: 1px solid #adadad;
  border-color: rgba(173, 173, 173, 0.3);
  height: 60px;
  display: flex;
  align-items: center;
}

.line_half_content,
.line_half_content {
  text-align: left;
}
.line_half_content .repeat_content {
  display: inline-block;
}

.line_half_content .repeat_content br {
  display: none;
}
.line_half_content .repeat_content .repeat_button {
  cursor: pointer;
  width: 100%;
  display: inline-block;
  width: 18px;
  margin-left: 4px;
  margin-right: 2px;
}

.word_space br {
  display: none;
}

.option {
  text-align: left; /* image 정렬 */
  border-bottom: none;
}

.option div {
  margin: 30px 45px 0 0;
  display: inline-block;
  color: #494949;
  font-size: 1.3em;
  text-align: center; /* 이미지 내용 정렬 */
}
.option div i {
  font-size: 3.52em;
}

/* 실거래가 그래프 */
div.chart-area #line-chart {
  height: 50vh !important;
}
div.chart-area #bar-chart {
  height: 50vh !important;
}

/*====color====*/
.jvo-impot {
  color: #8a5dff;
}

@media screen and (max-width: 1839px) {
  .word_space br {
    display: block;
  }
  .line {
    font-size: 1.15em;
  }
  .line_half_content .repeat_content .repeat_button {
    width: 16px;
    margin-left: 0px;
  }
}
@media screen and (max-width: 1289px) {
  .line_half_content .repeat_content br {
    display: block;
  }
}
@media screen and (max-width: 1200px) {
  div.vrpano_wrapper {
    height: 50vh;
    margin-top: 0;
  }
  .jipvio_title {
    margin-top: 0;
    margin-bottom: 10px;
  }
  .jipvio_title ul {
    height: 10vh;
  }

  div.overlayTestInner {
    width: 100%;
    height: 110vh;
    margin: 0;
  }
  #imageOb div:nth-of-type(1) .el-carousel__container {
    height: 428px;
  }

  #imageOb div:nth-of-type(3) .el-carousel__container {
    height: 30vh;
    margin-top: 8px;
  }
  #imageOb .el-carousel__button {
    width: 4vw;
  }
  .line {
    border-bottom: 1px solid #adadad;
    border-color: rgba(173, 173, 173, 0.3);
  }
  .line_half .mx-w1,
  .line_half .mx-w2 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .line_half .mx-w2 {
    margin: 0;
  }
  .line_half .mx-w2 .mx-w2_1,
  .line_half .mx-w2 .mx-w2_2 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .line_half_content .repeat_content br {
    display: none;
  }

  .line .line_half.border-ctl {
    border: none;
  }
}
@media screen and (min-width: 992px) {
  .property-detail #section1 h6 {
    font-size: 1.2em;
  }
  .property-detail #section2 h6 {
    font-size: 1.2em;
  }
}
@media screen and (max-width: 992px) {
  .line {
    border-bottom: 1px solid #adadad;
    border-color: rgba(173, 173, 173, 0.3);
  }

  .section_title,
  .section_title2 {
    padding: 0 9px;
  }
  .line_half h6 {
    margin-left: 9px;
  }
  .option div {
    font-size: 1em;
    margin: 10px 54px 0 12px;
  }
}
@media screen and (max-width: 848px) {
  .line_half_content .repeat_content br {
    display: block;
  }
}

@media screen and (max-width: 817px) {
  .line {
    font-size: 1.1em;
  }
}
@media screen and (max-width: 768px) {
  /* main wrapper */
  .features-1.property-detail {
    padding: 65px 0;
  }
  /* el-tooltip */
  .tooptip_style_1,
  .tooptip_style_2 {
    font-size: 16px;
  }
  .tooptip_style_2 {
    margin: 0 17.67px;
  }

  .section_title h4 {
    margin-right: 3.33px;
  }
  .jivpio_tooltip2 {
    width: 351px;
  }
  .jivpio_tooltip2 div {
    font-size: 16px;
  }

  .jivpio_tooltip2 table {
    margin-top: 13px;
    letter-spacing: -0.5px;
  }

  .jipvio_title ul {
    height: 60px;
    font-size: 1.7em;
    margin-bottom: 0;
  }
  .jipvio_title .title_hide {
    display: none;
  }

  .jipvio_title .middle_line {
    position: relative;
  }

  #DT_MapWrap {
    height: 60vh;
  }
  /* .jipvio_title .middle_line::after {
    content: "";
    width: 3px;
    height: 70%;
    background-color: #000;
    position: absolute;
    top: 5px;
    right: -29.5px;
  } */

  .jipvio_title ul li:nth-of-type(3) {
    margin: 0;
  }

  .jipvio_title ul li:nth-of-type(4) button {
    position: absolute;
    top: 50%;
    right: 33px;
    transform: translateY(-50%);
  }
  #section7 div iframe {
    height: 40vh;
  }
  #section7 div.vill-info-video iframe {
    height: 40vh;
  }
  .line_half_content .repeat_content br {
    display: none;
  }
  .line_half_content .repeat_content .repeat_button {
    width: 12px;
    margin-left: 1px;
  }
  .line .line_half.border-ctl.border-ctl {
    border-bottom: 1px solid #adadad;
    border-color: rgba(173, 173, 173, 0.3);
  }

  /* .section_title h4,
  .section_title2 h4, */
  .section_title2 p {
    font-size: 1em;
  }
  .section_title h4 span {
    font-size: 0.8em;
    margin-left: 10px;
  }
  .button_hide {
    margin: 39px 0;
  }
}

@media screen and (max-width: 767px) {
  .line {
    height: auto;
    border: none;
  }
  .line .line_half {
    height: 36px;
    border-bottom: 1px solid;
    border-color: rgba(173, 173, 173, 0.3);
  }
}

@media screen and (max-width: 600px) {
  div.overlayTest .close_btn {
    top: 2%;
    right: 2%;
    padding: 8px;
  }
  .tooltip_P {
    padding-left: 4px;
  }
  .el-tooltip__popper.jivpio_tooltip1,
  .el-tooltip__popper.jivpio_tooltip2,
  .el-tooltip__popper.jivpio_tooltip3 {
    background: #6a6a6a !important;
    font-size: 0.9rem;
  }
  .el-tooltip__popper.jivpio_tooltip1 {
    width: auto;
  }

  .el-tooltip__popper.jivpio_tooltip2 {
    width: 306.53px;
  }

  .el-tooltip__popper.jivpio_tooltip3 {
    width: 311px;
  }
  .el-tooltip__popper.jivpio_tooltip3 div {
    padding: 7px 10px 0 10px;
  }
  .el-tooltip__popper.jivpio_tooltip1 div p,
  .el-tooltip__popper.jivpio_tooltip2 div p,
  .el-tooltip__popper.jivpio_tooltip3 div p {
    font-size: 14px;
  }

  .el-tooltip__popper.jivpio_tooltip2 table {
    font-size: 12px;
    letter-spacing: -0.5px;
  }
  .el-tooltip__popper.jivpio_tooltip2 table tr th:nth-of-type(3) {
    padding-left: 0;
    text-align: center;
  }

  #imageOb div:nth-of-type(1) .el-carousel__container {
    height: 201px;
  }

  #imageOb div:nth-of-type(3) .el-carousel__container {
    height: 20vh;
  }

  .jipvio_title ul {
    /* justify-content: left; */
    font-size: 1.4em;
    padding-left: 7px !important;
  }
  /* .jipvio_title ul li:nth-of-type(2) {
    margin-right: 27px;
  } */

  .jipvio_title .middle_line::after {
    width: 1.5px;
    height: 70%;
    top: 4px;
    right: -15.5px;
  }
  .jipvio_title ul li:nth-of-type(4) button {
    width: 75.86px;
    height: 21.75px;
    font-size: 0.85em;
    padding: 10px;
    margin-left: 46px;
    position: inherit;
    transform: none;
  }
  #DT_MapWrap {
    height: 55vh;
  }
  .line .line_half .ml-reset {
    margin-left: 0;
  }

  #section7 div iframe {
    height: 35vh;
  }
  #section7 div.vill-info-video iframe {
    height: 35vh;
  }
  .option div {
    margin: 10px 12px 0 5px;
  }
  .button_hide {
    display: none;
  }
  .vill-info-video h4 {
    letter-spacing: -0.9px;
    font-size: 1.4em;
  }
  .vill-info-video p {
    letter-spacing: -1.1px;
    font-size: 1.1rem;
  }
}
@media screen and (min-width: 768px) {
  .property-detail #section1 h6 {
    font-size: 1.1em;
  }
  .property-detail #section2 h6 {
    font-size: 1.1em;
  }
}
@media screen and (max-width: 497px) {
  .line_half_content .repeat_content br {
    display: block;
  }
  .option div {
    font-size: 0.711em;
  }
}

@media screen and (max-width: 440px) {
  .line {
    font-size: 0.9em;
  }
  .line_half_content .repeat_button {
    width: 10px;
    margin-left: 0px;
  }
  #section5 .section_title2 p {
    letter-spacing: -5%;
  }
  .tooptip_style_2 {
    margin: 0 8.67px 0 11.67px;
  }
  div.overlayTestInner .el-carousel {
    height: 88vh;
  }
  #DT_RVMapWrap {
    width: 100%;
    height: 100%;
  }
}
</style>
